module.exports = __webpack_public_path__ + "img/213-Vert Monument.jpg";